<template>
    <Modal v-if="visible" :isNewMark="true" :hideActions="false" :maxWidth="'sm:max-w-2xl'" @modal:close="handleClose()">
        <template #body>
            <div v-if="!loading" class="font-[Inter] mt-2 text-[#2A8176] text-2xl text-left font-medium">
                {{ !loaded ? 'Target Resume for a New Role' : 'Your Resume Has Been Tailored!' }}
            </div>
            <div v-if="!loading" class="mt-2 font-[Roboto] text-[#686E77] font-normal text-left text-sm">
                {{ !loaded ? 'If you are looking to transition to a new role, we recommend tailoring your resume to the requirements of your desired role. Make sure you are using a complete resume for best results!' : 'If you are looking to transition to a new role, we recommend tailoring your resume to the requirements of your desired role. Make sure you are using a complete resume for best results!' }}
            </div>

            <div v-if="!loading && ! loaded">
                <TextInput
                    v-model="targetJob"
                    placeholder="e.g. Project Manager, Software Engineer, Sales Intern"
                >
                    Target Role
                </TextInput>

                <TextAreaInput
                    v-model="responsibilities"
                >
                    Copy & Paste the responsibilities of your desired role (Minimum: 3 sentences)
                </TextAreaInput>

                <button
                    :disabled="isDisabled"
                    :class="[
                        {
                            'won-green-button-color': !isDisabled,
                            'won-green-button-color-disabled': isDisabled,
                        },
                        buttonStyle,
                        'mt-8',
                    ]"
                    @click="handleSubmit()"
                >
                    <div class="flex items-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">                            <path d="M9.68018 10.3871L9.6802 10.3872L9.99902 10.5V10.6C9.99906 10.6 9.9991 10.6 9.99913 10.6C10.0906 10.6 10.1785 10.5636 10.2431 10.4987L10.2431 10.4987L10.2443 10.4975L16.9989 3.48836C17.1329 3.3535 17.1327 3.13557 16.9982 3.00105C16.8634 2.8663 16.645 2.86635 16.5102 3.00101L16.5102 3.001L16.5088 3.00237L9.7543 10.0117C9.65618 10.1104 9.62689 10.2584 9.68018 10.3871Z" fill="white" stroke="white" stroke-width="0.2"/>                            <path d="M7.81211 12.532C7.70307 12.5319 7.60061 12.48 7.53588 12.3923C7.47116 12.3046 7.45183 12.1912 7.48404 12.0871L8.3859 9.17585C8.42149 9.06081 8.51474 8.97278 8.63161 8.94394C8.74848 8.91496 8.87195 8.94931 8.95708 9.03444L10.9662 11.043C11.0513 11.1282 11.0856 11.2516 11.0566 11.3685C11.0278 11.4854 10.9398 11.5786 10.8247 11.6142L7.91396 12.5161C7.88098 12.5263 7.84678 12.5317 7.81212 12.532L7.81211 12.532ZM8.87162 9.92312L8.33142 11.6676L10.0775 11.129L8.87162 9.92312Z" fill="white"/>                            <path d="M7.81211 12.532C7.70307 12.5319 7.60061 12.48 7.53588 12.3923C7.47116 12.3046 7.45183 12.1912 7.48404 12.0871L8.3859 9.17585C8.42149 9.06081 8.51474 8.97278 8.63161 8.94394C8.74848 8.91496 8.87195 8.94931 8.95708 9.03444L10.9662 11.043C11.0513 11.1282 11.0856 11.2516 11.0566 11.3685C11.0278 11.4854 10.9398 11.5786 10.8247 11.6142L7.91396 12.5161C7.88098 12.5263 7.84678 12.5317 7.81212 12.532L7.81211 12.532ZM8.87162 9.92312L8.33142 11.6676L10.0775 11.129L8.87162 9.92312Z" stroke="white"/>                            <path d="M14.7423 5.60137C14.6486 5.60153 14.559 5.56334 14.4941 5.49585C14.4293 5.42837 14.3949 5.33726 14.3987 5.2437L14.5078 2.61162C14.5113 2.52558 14.547 2.44398 14.6078 2.38309L16.3888 0.602102C16.4852 0.504094 16.6309 0.472958 16.759 0.523267C16.8872 0.573419 16.973 0.695201 16.9771 0.83278L17.0514 2.94877L19.1673 3.02346C19.304 3.02822 19.4249 3.11365 19.475 3.2408C19.5252 3.3681 19.4951 3.51289 19.3983 3.60967L17.617 5.3905C17.5561 5.45139 17.4745 5.48712 17.3885 5.49065L14.7564 5.60108L14.7423 5.60137ZM15.1901 2.77435L15.1012 4.8989L17.2257 4.80994L18.3539 3.68215L16.7251 3.62464H16.725C16.5378 3.61099 16.3891 3.46221 16.3754 3.2751L16.3179 1.64626L15.1901 2.77435Z" fill="white"/>                            <path d="M14.7423 5.60137C14.6486 5.60153 14.559 5.56334 14.4941 5.49585C14.4293 5.42837 14.3949 5.33726 14.3987 5.2437L14.5078 2.61162C14.5113 2.52558 14.547 2.44398 14.6078 2.38309L16.3888 0.602102C16.4852 0.504094 16.6309 0.472958 16.759 0.523267C16.8872 0.573419 16.973 0.695201 16.9771 0.83278L17.0514 2.94877L19.1673 3.02346C19.304 3.02822 19.4249 3.11365 19.475 3.2408C19.5252 3.3681 19.4951 3.51289 19.3983 3.60967L17.617 5.3905C17.5561 5.45139 17.4745 5.48712 17.3885 5.49065L14.7564 5.60108L14.7423 5.60137ZM15.1901 2.77435L15.1012 4.8989L17.2257 4.80994L18.3539 3.68215L16.7251 3.62464H16.725C16.5378 3.61099 16.3891 3.46221 16.3754 3.2751L16.3179 1.64626L15.1901 2.77435Z" stroke="white"/>                            <path d="M8.53901 4.18728H8.61391C12.5904 4.2276 15.8129 7.47508 15.8127 11.4612C15.8127 15.4724 12.5501 18.7358 8.53901 18.7358C4.52792 18.7358 1.26454 15.4721 1.26454 11.4612C1.26454 7.45029 4.52802 4.18728 8.53901 4.18728ZM0.4 11.4612C0.4 15.9492 4.05112 19.6004 8.53901 19.6004C13.0269 19.6004 16.6777 15.9469 16.6777 11.4612C16.6777 6.97555 13.0269 3.32258 8.53901 3.32273C4.0511 3.32273 0.4 6.97313 0.4 11.4612Z" fill="white" stroke="white" stroke-width="0.2"/>                            <path d="M4.89548 7.72874C3.88924 8.67891 3.32285 9.96894 3.32285 11.3154C3.32285 12.6619 3.88924 13.9519 4.89548 14.9021C5.90135 15.8521 7.2645 16.3849 8.68463 16.3849L8.68477 16.3849C10.1043 16.3829 11.4664 15.8495 12.4717 14.9C13.4774 13.9502 14.0445 12.6613 14.0464 11.3155V11.3154C14.0464 9.96894 13.48 8.67891 12.474 7.72874C11.4681 6.77875 10.1049 6.24595 8.68463 6.24595C7.2645 6.24595 5.90135 6.77875 4.89548 7.72874ZM4.89548 7.72874L4.96414 7.80144L4.89548 7.72874ZM8.68463 7.16895H8.78658L8.78656 7.16793C9.91724 7.19416 10.9946 7.62998 11.7945 8.38577L11.8632 8.31308L11.7945 8.38577C12.6182 9.16393 13.0801 10.2178 13.0811 11.3157C13.081 12.4134 12.6193 13.4676 11.7954 14.2457C10.9713 15.024 9.85253 15.4622 8.68463 15.4622C7.51694 15.4622 6.39795 15.024 5.57384 14.2457C4.74993 13.4675 4.2882 12.4133 4.2882 11.3156C4.2882 10.2178 4.74993 9.1636 5.57384 8.38546C6.39795 7.60713 7.5169 7.16895 8.68463 7.16895Z" fill="white" stroke="white" stroke-width="0.2"/>                            </svg>
                        <div class="ml-2 flex justify-center items-center">
                            <span class="pl-1">Target</span>
                        </div>
                    </div>
                </button>
                <p class="font-[Inter] italic text-xs text-[#5E5E5E] font-normal mt-4">Reminder: Clicking “Target” uses 10 tokens!</p>
            </div>

            <div v-else-if="loading" class="flex flex-col items-center justify-centers">
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.9256 16.175C23.9756 15.8 24.0006 15.4125 24.0006 15C24.0006 14.6 23.9756 14.2 23.9131 13.825L26.4506 11.85C26.6756 11.675 26.7381 11.3375 26.6006 11.0875L24.2006 6.9375C24.0506 6.6625 23.7381 6.575 23.4631 6.6625L20.4756 7.8625C19.8506 7.3875 19.1881 6.9875 18.4506 6.6875L18.0006 3.5125C17.9506 3.2125 17.7006 3 17.4006 3H12.6006C12.3006 3 12.0631 3.2125 12.0131 3.5125L11.5631 6.6875C10.8256 6.9875 10.1506 7.4 9.53813 7.8625L6.55063 6.6625C6.27562 6.5625 5.96313 6.6625 5.81313 6.9375L3.42563 11.0875C3.27563 11.35 3.32563 11.675 3.57563 11.85L6.11313 13.825C6.05063 14.2 6.00063 14.6125 6.00063 15C6.00063 15.3875 6.02563 15.8 6.08813 16.175L3.55063 18.15C3.32563 18.325 3.26313 18.6625 3.40063 18.9125L5.80063 23.0625C5.95063 23.3375 6.26313 23.425 6.53813 23.3375L9.52563 22.1375C10.1506 22.6125 10.8131 23.0125 11.5506 23.3125L12.0006 26.4875C12.0631 26.7875 12.3006 27 12.6006 27H17.4006C17.7006 27 17.9506 26.7875 17.9881 26.4875L18.4381 23.3125C19.1756 23.0125 19.8506 22.6125 20.4631 22.1375L23.4506 23.3375C23.7256 23.4375 24.0381 23.3375 24.1881 23.0625L26.5881 18.9125C26.7381 18.6375 26.6756 18.325 26.4381 18.15L23.9256 16.175ZM15.0006 19.5C12.5256 19.5 10.5006 17.475 10.5006 15C10.5006 12.525 12.5256 10.5 15.0006 10.5C17.4756 10.5 19.5006 12.525 19.5006 15C19.5006 17.475 17.4756 19.5 15.0006 19.5Z" fill="#96AAB7"/>
                </svg>

                <div class="w-[188px] h-[4px] bg-[#F4F4F4] rounded-full mt-2">
                    <div :style="{'width': `${progress}%`}" :class="['bg-[#2A8176] h-full rounded-full transition-all ease-out duration-1000']"></div>
                </div>
                    
                <p class="font-[Inter] font-normal text-2xl text-[#182333] mt-4">
                    Targeting your resume to the job description of a 
                </p>
                <p class="font-[Inter] font-normal text-2xl text-[#2A8176]">
                    Project Manager!
                </p>

                <p class="font-[Roboto] font-normal text-base text-[#505D68] mt-4">
                    Hold tight! Your results will be ready in a minute.
                </p>
            </div>

            <div v-if="loaded" class="mt-6">
                <div class="flex justify-center items-center">
                    <pdf-preview-card
                        v-for="item of [resume]"
                        :key="item.uuid"
                        :preview="item"
                        :hideActions="true"
                    />
                </div>

                <button
                    :class="[
                        buttonStyle,
                        'mt-8 won-green-button-color',
                    ]"
                    @click="handleReset()"
                >
                    <div class="flex items-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1216_60294)"><path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="white"/></g><defs><clipPath id="clip0_1216_60294"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>
                        <div class="ml-2 flex justify-center items-center">
                            <span class="pl-1">Target again</span>
                        </div>
                    </div>
                </button>
                <p class="font-[Inter] italic text-xs text-[#5E5E5E] font-normal mt-4">Reminder: Clicking “Target” uses 10 tokens!</p>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import Modal from "../components/modal";

import { onMounted, toRefs, ref, computed } from 'vue'
import TextInput from "../forms/elements/text.vue";
import TextAreaInput from "../forms/elements/textarea.vue";

import PdfPreviewCard from '../components/pdf/pdf-preview-card'

import { tailorResume } from '../api/builder'
import { useTokens } from '../store/token.store'

import { buttonStyle } from "../utils/styles";

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    }
})

const { visible } = toRefs(props)
const emit = defineEmits(["delete-modal:close"])

const targetJob = ref(null)
const responsibilities = ref(null)
const loading = ref(false)
const loaded = ref(false)
const progress = ref(0)
const resume = ref({})

const isDisabled = computed(() => {
    return !targetJob.value || !responsibilities.value
})

const tokensStore = useTokens()
 
const handleSubmit = () => {
    loading.value = true

    tailorResume({
        'target_job': targetJob.value,
        'responsibilities': responsibilities.value,
    })
        .then(async(res) => {
            for(let i = 1; i<=10; i++) {
                await new Promise(resolve => setTimeout(resolve, 300));
                progress.value = i*10
            }

            resume.value = res

            // refresh tokens utilization
            tokensStore.refresh()
        }).finally(() => {
            loading.value = false
            loaded.value = true
        })
}

const handleReset = () => {
    targetJob.value = null
    responsibilities.value = null
    loading.value = false
    loaded.value = false
    progress.value = 0
    resume.value = null
}

onMounted(() => {
    document.onkeydown = function(e) {
        if(e.key == 'Escape' && visible.value) {
            handleClose()
        }
    }
})

const handleClose = (message = null) => {
    handleReset()
    emit("delete-modal:close", message);
}

</script>
